import React from "react";

export default function footer() {
  return (
    <div>
      This was code was coded by Ashley Wallace and is{" "}
      <a
        href="https://github.com/ashleyNwallace/react-weather-app"
        target="_blank"
        rel="noreferrer"
      >
        open-sourced on Github
      </a>
      and is hosted on Netlify
    </div>
  );
}
